// Module
var code = `<ex-mono-occurrence-ecran formulaire="vm.formulaireCqc" mono-occurrence-options="vm.monoOccurrenceOptions" mono-occurrence-out="vm.monoOccurrence" largeur-formulaire="50"> </ex-mono-occurrence-ecran> `;
// Exports
module.exports = code;